import { render, staticRenderFns } from "./DkWizardLeadFormScrollWrapper.vue?vue&type=template&id=5776c1d3&"
import script from "./DkWizardLeadFormScrollWrapper.vue?vue&type=script&lang=js&"
export * from "./DkWizardLeadFormScrollWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports